import { navigationQueryName } from '.';

export const routeNames = {
  home: 'home',
  notFound: 'notFound',
  dataItem: 'dataItem',
};

export const historyPushQuery = (name: string, query: string): void => {
  const url: URL = new URL(window.location as any);
  url.searchParams.set(navigationQueryName, query);
  window.history.pushState({}, '', url as any);
};
